import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Paper } from "@mui/material";
import Header from "../../../components/Header";
import IncomeExpenseChart from "../IncomeExpenseChart";
import AnnualIncome from "./AnnualIncome";
import MonthlyIncome from "./MonthlyIncome";
import DailyCashFlow from "./DailyCashFlow";
import AnnualIncomeExpTable from "./AnnualIncomeExpTable";
import IncomeExpenseByMonth from "./IncomeExpenseByMonth";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AnnualReports() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "70%" }}
        elevation={3}
      >
        <Header title="Cash Flow / Reports" subtitle="Annual / Monthly " />
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            width: "100%",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Daily Cash FLOW" {...a11yProps(0)} />
            <Tab label="ANNUAL INCOME / EXPENSE STATEMENT" {...a11yProps(1)} />
            <Tab label="Monthly Income / Expese Review" {...a11yProps(2)} />
            <Tab label="Annual Income" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <DailyCashFlow />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <AnnualIncomeExpTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <IncomeExpenseByMonth />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <AnnualIncome />
        </CustomTabPanel>
      </Paper>
    </Box>
  );
}
